const GOOGLE_ADS_BOOKING_CONVERSION = 'AW-18220230097/fglyCOn53rscENHLivBD';

export const trackBookingConversion = (transactionId) => {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') {
    return;
  }

  window.gtag('event', 'conversion', {
    send_to: GOOGLE_ADS_BOOKING_CONVERSION,
    transaction_id: transactionId,
  });
};

export const createTrackingTransactionId = () => {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }

  return `booking-${Date.now()}`;
};
